import { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';

import { router } from '@core/router';
import { ErrorBoundary } from '@shared/components/feedback/ErrorBoundary';
import { ToastProvider } from '@shared/components/feedback/ToastProvider';
import { LoadingSpinner } from '@shared/components/feedback/LoadingSpinner';

/**
 * Root Application Component
 *
 * Provides global error boundary, toast notifications, and routing.
 * Uses Suspense for lazy-loaded route components.
 */
function App() {
    return (
        <ErrorBoundary>
            <ToastProvider>
                <Suspense
                    fallback={
                        <div className="flex min-h-screen items-center justify-center">
                            <LoadingSpinner size="lg" />
                        </div>
                    }
                >
                    <RouterProvider router={router} />
                </Suspense>
            </ToastProvider>
        </ErrorBoundary>
    );
}

export default App;
